import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Icon, IconSize, type IconProps } from '@shared/icons';
import { APP_CONFIG } from '../../../../config/app.config';

interface DashboardCardHeaderProps {
  title: string;
  subtitle?: string;
  icon?: IconProps['icon'];
  children?: React.ReactNode;
  divider?: boolean;
}

const DashboardCardHeader: React.FC<DashboardCardHeaderProps> = ({
  title,
  subtitle,
  icon,
  children,
  divider = false,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0}
      sx={{
        width: '100%',
        minWidth: 0,
        overflow: 'hidden',
        ...(divider && {
          borderBottom: 1,
          borderColor: colors.border,
        }),
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        p={2}
        flex={1}
        minWidth={0}
        overflow="hidden"
      >
        {icon && (
          <Icon icon={icon} size={IconSize.MEDIUM} color={colors.primaryText} />
        )}
        <Stack flex={1} minWidth={0} overflow="hidden">
          <Typography
            variant="subtitle1"
            fontWeight={600}
            color="text.primary"
            noWrap
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" noWrap>
              {subtitle}
            </Typography>
          )}
        </Stack>
      </Stack>

      {children && (
        <Stack direction="row" alignItems="center" gap={1} flexShrink={0} px={2}>
          {children}
        </Stack>
      )}
    </Stack>
  );
};

export default DashboardCardHeader;
